import { render, staticRenderFns } from "./send-status.vue?vue&type=template&id=bbae8140&scoped=true&"
import script from "./send-status.vue?vue&type=script&lang=js&"
export * from "./send-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbae8140",
  null
  
)

export default component.exports